export default import.meta.ROLLUP_FILE_URL_svZbZ1cfgqDeibEeZOM5Ww